import dateFormat from '../lib/dateFormat';

export const dateFormatter = (cell, row) => {
  return (
    <span className="date-formatter">
      {dateFormat(cell)}
    </span>
  );
}
